// extracted by mini-css-extract-plugin
export default {"form":"Register_form__rss2E"};